import { Component, OnInit, ViewChild ,AfterViewInit} from '@angular/core';
import { AvtListesComponent } from '../avt-listes/avt-listes.component';

@Component({
  selector: 'app-avt-suivie-ped-note',
  templateUrl: './avt-suivie-ped-note.component.html',
  styleUrls: ['./avt-suivie-ped-note.component.scss']
})
export class AvtSuiviePedNoteComponent implements OnInit ,AfterViewInit
{

  constructor() { }
  exist : boolean = true;
  buttonDisabled : boolean = false;
  listeGroupe = [{text:"g1",value:"1"},{text:"g2",value:"2"}];
  listePeriode = [{text:"Première période",value:"1"},{text:"Seconde période",value:"2"}];
  listeType = [{text:"T1",value:"1"},{text:"T2",value:"2"}];
  listematiere = [{text:"m1",value:"1"},{text:"m2",value:"2"}];
  listeFormateur = [{text:"f1",value:"1"},{text:"f2",value:"2"}];
  noteEvaluation;
  columnsEvaluation =
  {
    "TableRD":
        [
          {"TableRE_Code":"","TableRD_Champs":"apprenantsNoteEvaluation","Lg_Code":"","TableRD_Des":"Apprenants","TableRD_Largeur":150,"TableRD_ReadOnly":true,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":4,"TableRD_Type":7,"TableRD_Param1":null,"TableRD_Param2":"number","TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
          {"TableRE_Code":"","TableRD_Champs":"noteEvaluation","Lg_Code":"","TableRD_Des":"Notes","TableRD_Largeur":70,"TableRD_ReadOnly":false,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":4,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":"number","TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
          {"TableRE_Code":"","TableRD_Champs":"oldNoteEvaluation","Lg_Code":"","TableRD_Des":"Notes antérieures","TableRD_Largeur":70,"TableRD_ReadOnly":true,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":4,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":"number","TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
          {"TableRE_Code":"","TableRD_Champs":"CommentaireNoteEvaluation","Lg_Code":"","TableRD_Des":"Commentaire Evaluation","TableRD_Largeur":300,"TableRD_ReadOnly":false,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":5,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
        ]
  }
  listeEvaluations = 
  [
    {apprenantsNoteEvaluation :"<img src='../../assets/avatar.png' style='width : 60px;margin-right : 10px'> apprenant 1",noteEvaluation:"5", oldNoteEvaluation:"2", CommentaireNoteEvaluation : "commentaire 1"},
    {apprenantsNoteEvaluation :"<img src='../../assets/avatar.png' style='width : 60px;margin-right : 10px'> apprenant 1",noteEvaluation:"5", oldNoteEvaluation:"2", CommentaireNoteEvaluation : "commentaire 1"}
  ]
  listBtnEvaluation:Array<any> = 
  [
    {name:"exporter",class:"colorGreen",text:"Exporter",disabled:false},
    {name:"importer",class:"colorGreen",text:"Importer",disabled:false}
  ]  
  @ViewChild("listeEvaluationComponen", {static : false}) listeEvaluationComponen : AvtListesComponent;
      
  ngOnInit() 
  {
    this.noteEvaluation = {};
  }
  ngAfterViewInit()
  {
    this.listeEvaluationComponen.setDataSource(this.listeEvaluations);
  }
  enregister()
  {

  }
  clickBtnHeat(event)
  {
    switch (event.name)
    {
      case "exporter":
      {
        break;
      }
      case "importer":
      {
        break;
      }
    }
  }
}
